import { CONTACT } from "@/data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-line/10 bg-base py-14">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-6 md:flex-row md:items-center md:px-12">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-4">
            <span className="logo-chip flex items-center">
              <img
                src="/aci-logo.png"
                alt="ACI Automation Control Instrumentation logo"
                className="h-16 w-auto"
                loading="lazy"
              />
            </span>
            <span className="logo-chip flex items-center">
              <img src="/cl-logo.png" alt="Caldwell Levesque logo" data-testid="footer-cl-logo" className="h-8 w-auto" loading="lazy" />
            </span>
          </div>
          <div>
            <p data-testid="footer-legal-name" className="font-heading text-sm font-semibold tracking-tight text-ink">
              ACI Automation Control Instruments Ltd
            </p>
            <p data-testid="footer-partner-line" className="mt-0.5 text-xs text-body">
              ACI — in partnership with Caldwell Levesque
            </p>
            <p className="mt-1 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-dim">
              IANZ-accredited laboratory · Blue Tick · IQP
            </p>
          </div>
        </div>
        <address className="text-sm not-italic leading-relaxed text-body">
          <a href={CONTACT.mapUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-map-link" className="hover:text-brand">
            {CONTACT.address}
          </a>{" "}
          ·{" "}
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="hover:text-brand">
            {CONTACT.email}
          </a>
        </address>
      </div>
      <div className="mx-auto mt-12 flex max-w-7xl flex-wrap items-center justify-between gap-3 border-t border-line/10 px-6 pt-6 md:px-12">
        <p className="text-xs text-dim">
          © {year} ACI Automation Control Instruments Ltd. All rights reserved. · instruments.nz
        </p>
        <p className="hud-label">NGĀRUAWĀHIA // HAMILTON // AUCKLAND</p>
      </div>
    </footer>
  );
}
